module.exports = __webpack_public_path__ + "static/media/t-mobile.c7148c50.svg";